<template>
    <div></div>
</template>

<script>
    export default {
        props: {
            ex: {
                type: Number,
                default: 0,
            },
        },

        computed: {},
    }
</script>
